import gql from 'graphql-tag'

export default gql`
  query listGitHubRepos($login: String!) {
    listGitHubRepos(login: $login) {
      success
      errorText
      resData {
        id
        name
        full_name
        description
        html_url
        private
        language
        owner {
          login
          avatar_url
        }
      }
    }
  }
`
